module.exports = __webpack_public_path__ + "assets/img/7.e43e0f70.jpg";